const DEFAULT_CLIENT_DATA = { loaded: false };

const getPartner = (state, partnerId) => state.entities.partners[partnerId];

export const getClientData = state => {
  const { loaded, loading, client } = state.currentFolder.header;
  if (!loaded || loading || !client.loaded || !client.clientId) return DEFAULT_CLIENT_DATA;

  const partner = getPartner(state, state.currentFolder.header.client.clientId);
  const { partnerId, partnerName, ...folderClient } = partner;

  return {
    loaded: client.loaded,
    clientId: partnerId,
    clientName: partnerName,
    ...folderClient
  };
};

export const getDocumentType = state => {
  return state.currentFolder.header.documentTypeId;
};
